module.exports = {
	"id": "LY",
	"name": "Libya",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.009492,
			"5": 0.01582,
			"6": 0.01582,
			"7": 0.006328,
			"8": 0.01582,
			"9": 0.018984,
			"10": 0.009492,
			"11": 0.025312,
			"12": 0.009492,
			"13": 0.041132,
			"14": 0.056952,
			"15": 0.2373,
			"16": 0.034804,
			"17": 0.066444,
			"18": 0.012656,
			"19": 0.022148,
			"20": 0.01582,
			"21": 0.003164,
			"22": 0.009492,
			"23": 0.025312,
			"24": 0.034804,
			"25": 0.034804,
			"26": 0.037968,
			"27": 0.025312,
			"28": 0.018984,
			"29": 0.041132,
			"30": 0.018984,
			"31": 0.075936,
			"32": 0.050624,
			"33": 0.335384,
			"34": 0.025312,
			"35": 0.01582,
			"36": 0.022148,
			"37": 0.009492,
			"38": 0.053788,
			"39": 0.091756,
			"40": 0.053788,
			"41": 0.041132,
			"42": 0.034804,
			"43": 0.708736,
			"44": 0.037968,
			"45": 0.044296,
			"46": 0.03164,
			"47": 0.120232,
			"48": 0.09492,
			"49": 0.623308,
			"50": 0.132888,
			"51": 0.98084,
			"52": 0.430304,
			"53": 12.393388,
			"54": 3.38548,
			"55": 0.091756,
			"56": 0.018984,
			"57": null
		},
		"firefox": {
			"2": 0.009492,
			"3": 0.025312,
			"4": 0.009492,
			"5": 0.009492,
			"6": 0.03164,
			"7": 0.009492,
			"8": 0.006328,
			"9": 0.009492,
			"10": 0.01582,
			"11": 0.009492,
			"12": 0.06328,
			"13": 0.012656,
			"14": 0.006328,
			"15": 0.012656,
			"16": 0.022148,
			"17": 0.012656,
			"18": 0.012656,
			"19": 0.006328,
			"20": 0.012656,
			"21": 0.009492,
			"22": 0.025312,
			"23": 0.006328,
			"24": 0.009492,
			"25": 0.088592,
			"26": 0.009492,
			"27": 0.018984,
			"28": 0.006328,
			"29": 0.0791,
			"30": 0.022148,
			"31": 0.012656,
			"32": 0.01582,
			"33": 0.03164,
			"34": 0.034804,
			"35": 0.022148,
			"36": 0.028476,
			"37": 0.01582,
			"38": 0.034804,
			"39": 0.034804,
			"40": 0.028476,
			"41": 0.025312,
			"42": 0.060116,
			"43": 0.215152,
			"44": 0.082264,
			"45": 0.09492,
			"46": 0.085428,
			"47": 0.597996,
			"48": 0.319564,
			"49": 2.474248,
			"50": 0.183512,
			"51": null,
			"52": null,
			"3.5": 0.006328,
			"3.6": 0.03164
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.006328,
			"15": null,
			"16": null,
			"17": 0.003164,
			"18": 0.006328,
			"19": null,
			"20": 0.009492,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012656,
			"30": null,
			"31": null,
			"32": 0.03164,
			"33": 0.018984,
			"34": 0.009492,
			"35": 0.01582,
			"36": 0.037968,
			"37": 0.037968,
			"38": 0.034804,
			"39": 0.050624,
			"40": 0.787836,
			"41": 0.104412,
			"42": 0.009492,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.025312,
			"11.6": 0.009492,
			"12.1": 0.050624
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.003164,
			"7": 0.009492,
			"8": 0.025312,
			"9": 0.037968,
			"10": 0.085428,
			"3.1": null,
			"3.2": null,
			"5.1": 0.009492,
			"6.1": null,
			"7.1": null,
			"9.1": 0.0791
		},
		"ios_saf": {
			"8": 0,
			"10": 2.78982225812,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0751824816819,
			"8.1-8.4": 0.138896449209,
			"9.0-9.2": 0.0662625262281,
			"9.3": 1.01092828476
		},
		"android": {
			"3": 0,
			"4": 0.17793030491,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0222412881137,
			"4.1": 0.641820028424,
			"4.2-4.3": 1.60455007106,
			"4.4": 3.67934451938,
			"4.4.3-4.4.4": 3.71111778811
		},
		"ie": {
			"6": 0.0224567807351,
			"7": 0.00641622306717,
			"8": 0.555003295311,
			"9": 0.301562484157,
			"10": 0.307978707224,
			"11": 1.33778250951,
			"5.5": null
		},
		"op_mob": {
			"0": 1.89844314463,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0527345317953
		},
		"edge": {
			"12": 0.072772,
			"13": 0.167692,
			"14": 0.215152
		},
		"ie_mob": {
			"10": 0.0134794366197,
			"11": 0.0548805633803
		},
		"bb": {
			"7": 0.003418,
			"10": null
		},
		"samsung": {
			"0": 2.399436
		},
		"and_uc": {
			"0": 2.180684
		},
		"op_mini": {
			"0": 25.5773943236
		},
		"and_chr": {
			"0": 21.825808
		},
		"and_ff": {
			"0": 0.03418
		}
	},
	"total": 98.23487
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LY.json
 ** module id = 581
 ** module chunks = 0
 **/